import Legal from '../components/Legal/Legal';

const LegalPage = () => {
    return (
        <>
            <Legal />
        </>
    )
}

export default LegalPage;